import { h } from 'preact'
export const IconCtaArrow = () => {
    return (
      <svg class="icon icon-cta-arrow" viewBox="0 0 15 13" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <g id="PLP-&amp;-Search-(Batch-2)" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="Type-Ahead---Mobile" transform="translate(-265.000000, -973.000000)" stroke="#444444" stroke-width="1.2">
                  <g id="Group-2" transform="translate(92.500000, 969.000000)">
                      <g id="Group-8" transform="translate(172.500000, 5.000000)">
                          <polyline id="Stroke-1" points="8.5 0 14 5.5 8.5 11"></polyline>
                          <line x1="14" y1="5.5001" x2="0" y2="5.5001" id="Stroke-3"></line>
                      </g>
                  </g>
              </g>
          </g>
      </svg>
    )
}
